<template>
  <div id="app">
    <el-row :gutter="20">
      <el-col :span="8">
        <div class="grid-content bg-purple">
          <div class="title">
            <p class="title-text">海洋观测系统动态监控平台</p>
          </div>
          <div class="second">
            <div>
              <div class="flexbox">
                <div class="kuang1">
                  <div class="kuang1-text1">经度</div>
                  <div class="kuang1-text">{{jd}}</div>
                </div>

                <div class="kuang2">
                  <div class="kuang1-text1">纬度</div>
                  <div class="kuang1-text">{{wd}}</div>
                </div>

              </div>
            </div>
            <div class="second-two">
              <div class="flexbox">

                <div class="kuang1">
                  <div class="kuang1-text1">波高</div>
                  <div class="kuang1-text">{{lg}}</div>
                </div>

                <div class="kuang2">
                  <div class="kuang1-text1">波周期</div>
                  <div class="kuang1-text">{{bzq}}</div>
                </div>

              </div>
            </div>
            <div class="second-two">
              <div class="flexbox">

                <div class="kuang1">
                  <div class="kuang1-text1">波向</div>
                  <div class="kuang1-text">{{bx}}</div>
                </div>

                <div class="kuang2">
                  <div class="kuang1-text1">温度</div>
                  <div class="kuang1-text">{{wend}}</div>
                </div>

              </div>
            </div>
            <div class="second-two">
              <div class="flexbox">

                <div class="kuang1">
                  <div class="kuang1-text1">气压</div>
                  <div class="kuang1-text">{{qy}}</div>
                </div>

                <div class="kuang2">
                  <div class="kuang1-text1">电压</div>
                  <div class="kuang1-text">{{dy}}</div>
                </div>

              </div>
            </div>
          </div>
          <div class="forth">
            <div>风向</div>
            <div class="forth1 flexbox">

              <div class="for-one">
                <div class="kedu">
                  <img src="../../public/static/kedu.png"
                       class="kedu1">
                </div>
                <div class="for-one1">

                </div>
                <div class="for-one2">
                  <img src="../../public/static/quanquan3.png"
                       class="img1"
                       ref="image"
                       :style="{transform: 'rotate(' + fx + 'deg)'}">

                </div>

                <div class="for-one4">
                  {{fx1}}
                </div>
              </div>
              <div class="for-two">
                <div class="for-two1">
                  <div class="for-two1text">风向</div>
                  <div class="for-two1text1">{{fx}}</div>
                </div>
                <div class="for-two2">
                  <div class="for-two1text">风速</div>
                  <div class="for-two1text1">{{fs}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="16">
        <div class="grid-content1 bg-purple1">
          <div class="right-frist">
            <div class="right-title flexbox">
              <div class="photo">
                <img src="../../public/static/shizhong.png">
              </div>
              <div class="time flexbox">
                <div class="time-text">时间
                </div>
                <div class="time-data">
                  {{sj}}
                </div>

              </div>
            </div>

            <div class="quxiantu">

              <div id="main"></div>

            </div>
            <div class="biaoge flexbox"
                 v-if="newfsdata&&newfsdata.length>0">
              <div class="biaoge-one">
                <div class="biaoge-one1 flexbox">
                  <div class="biaoge-one11">24h最大<br>风速</div>
                  <div class="biaoge-one121">
                    <div class="one12-text1">最大风速</div>
                    <div class="one12-text20">{{zdfs}}</div>
                  </div>
                  <div class="biaoge-one131">
                    <div class="one12-text1">最大风向</div>
                    <div class="one12-text20">{{zdfx}}</div>
                  </div>
                  <div class="biaoge-one141">
                    <div class="one12-text1">时间</div>
                    <div class="one12-text2">{{sj}}</div>
                  </div>
                </div>
                <div class="biaoge-one2">
                  <div class="biaoge-one21 flexbox">
                    <div class="biaoge-one211">
                      最新
                    </div>
                    <div class="biaoge-one212">时间</div>
                    <div class="biaoge-one213">风速</div>
                    <div class="biaoge-one214">风向</div>
                  </div>
                  <div class="biaoge-one22 flexbox">
                    <div class="biaoge-one221">1</div>
                    <div class="biaoge-one222">{{newfsdata[0][0]}}</div>
                    <div class="biaoge-one223">{{newfsdata[0][1]}}</div>
                    <div class="biaoge-one224">{{newfxdata[0][1]}}</div>
                  </div>
                  <div class="biaoge-one23 flexbox">
                    <div class="biaoge-one221">2</div>
                    <div class="biaoge-one222">{{newfsdata[1][0]}}</div>
                    <div class="biaoge-one223">{{newfsdata[1][1]}}</div>
                    <div class="biaoge-one224">{{newfxdata[1][1]}}</div>
                  </div>
                  <div class="biaoge-one24 flexbox">
                    <div class="biaoge-one221">3</div>
                    <div class="biaoge-one222">{{newfsdata[2][0]}}</div>
                    <div class="biaoge-one223">{{newfsdata[2][1]}}</div>
                    <div class="biaoge-one224">{{newfxdata[2][1]}}</div>
                  </div>
                  <div class="biaoge-one25 flexbox">
                    <div class="biaoge-one221">4</div>
                    <div class="biaoge-one222">{{newfsdata[3][0]}}</div>
                    <div class="biaoge-one223">{{newfsdata[3][1]}}</div>
                    <div class="biaoge-one224">{{newfxdata[3][1]}}</div>
                  </div>
                  <div class="biaoge-one26 flexbox">
                    <div class="biaoge-one221">5</div>
                    <div class="biaoge-one222">{{newfsdata[4][0]}}</div>
                    <div class="biaoge-one223">{{newfsdata[4][1]}}</div>
                    <div class="biaoge-one224">{{newfxdata[4][1]}}</div>
                  </div>
                </div>
              </div>
              <div class="biaoge-two">
                <div class="biaoge-two1 flexbox">
                  <div class="biaoge-two11">24h最大<br>波高</div>
                  <div class="biaoge-two12">
                    <div class="one12-text1">最大波高</div>
                    <div class="one12-text20">{{zdbg}}</div>
                  </div>
                  <div class="biaoge-two13">
                    <div class="one12-text1">波周期</div>
                    <div class="one12-text20">{{zbzq}}</div>
                  </div>
                  <div class="biaoge-two14">
                    <div class="one12-text1">波向</div>
                    <div class="one12-text20">{{zdbx}}</div>
                  </div>
                  <div class="biaoge-two15">
                    <div class="one12-text1">时间</div>
                    <div class="one12-text2">{{sj}}</div>
                  </div>
                </div>
                <div class="biaoge-two2">
                  <div class="biaoge-two21 flexbox">
                    <div class="biaoge-two211">最新</div>
                    <div class="biaoge-two212">时间</div>
                    <div class="biaoge-two213">波高</div>
                    <div class="biaoge-two214">波向</div>
                    <div class="biaoge-two215">风向</div>
                  </div>
                  <div class="biaoge-two22 flexbox">
                    <div class="biaoge-two221">1</div>
                    <div class="biaoge-two222">{{newfsdata[0][0]}}</div>
                    <div class="biaoge-two223">{{newbgdata[0][1]}}</div>
                    <div class="biaoge-two224">{{newbxdata[0][1]}}</div>
                    <div class="biaoge-two225">{{newfxdata[0][1]}}</div>
                  </div>
                  <div class="biaoge-two23 flexbox">
                    <div class="biaoge-two221">2</div>
                    <div class="biaoge-two222">{{newfsdata[1][0]}}</div>
                    <div class="biaoge-two223">{{newbgdata[1][1]}}</div>
                    <div class="biaoge-two224">{{newbxdata[1][1]}}</div>
                    <div class="biaoge-two225">{{newfxdata[1][1]}}</div>
                  </div>
                  <div class="biaoge-two24 flexbox">
                    <div class="biaoge-two221">3</div>
                    <div class="biaoge-two222">{{newfsdata[2][0]}}</div>
                    <div class="biaoge-two223">{{newbgdata[2][1]}}</div>
                    <div class="biaoge-two224">{{newbxdata[2][1]}}</div>
                    <div class="biaoge-two225">{{newfxdata[2][1]}}</div>
                  </div>
                  <div class="biaoge-two25 flexbox">
                    <div class="biaoge-two221">4</div>
                    <div class="biaoge-two222">{{newfsdata[3][0]}}</div>
                    <div class="biaoge-two223">{{newbgdata[3][1]}}</div>
                    <div class="biaoge-two224">{{newbxdata[3][1]}}</div>
                    <div class="biaoge-two225">{{newfxdata[3][1]}}</div>
                  </div>
                  <div class="biaoge-two26 flexbox">
                    <div class="biaoge-two221">5</div>
                    <div class="biaoge-two222">{{newfsdata[4][0]}}</div>
                    <div class="biaoge-two223">{{newbgdata[4][1]}}</div>
                    <div class="biaoge-two224">{{newbxdata[4][1]}}</div>
                    <div class="biaoge-two225">{{newfxdata[4][1]}}</div>
                  </div>
                </div>
              </div>
              <div class="biaoge-four">
                <div class="biaoge-four1">时间</div>
                <div class="biaoge-four2">
                  <div class="biaoge-four21">{{sj}}</div>
                  <!-- <div class="biaoge-four22">08:35:00</div> -->
                </div>
                <div class="biaoge-four3">
                  波向
                </div>
                <div class="biaoge-four4">
                  <div class="biaoge-four41">
                    <div class="biaoge-four411">
                    </div>
                    <div class="biaoge-four412">
                      <div class="boxiang">{{bx1}}</div>
                    </div>
                    <div :style="{transform: 'rotate(' + bx2 + 'deg)'}">

                      <div class="biaoge-four413">

                        <van-icon name="play"
                                  size="15px"
                                  color="#457FFF" />

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script >
import { bigfloaterkb } from '../service/getData'
import moment from 'moment'
const echarts = require('echarts')
let myChart
export default {
  data() {
    return {
      dtarray: null,
      jd: null,
      wd: null,
      lg: null,
      bzq: null,
      bx: null,
      bx1: null,
      bx2: null,
      wend: null,
      qy: null,
      dy: null,
      fx: null,
      fx1: null,
      fs: null,
      sj: null,
      zdfs: null,
      zdfx: null,
      zdbg: null,
      zbzq: null,
      zdbx: null,
      equipid: 14,
      number: 10,
      titlelist: null,
      datashuju: [],
      fsshuju: [],
      qyshuju: [],
      bgshuju: [],
      wdshuju: [],
      bzqshuju: [],

      bxshuju: [],
      dyzshuju: [],
      fxshuju: [],

      swshuju: [],
      newfsdata: [],
      newfxdata: [],
      newbgdata: [],
      newbxdata: [],
      bdt:
        null ||
        moment()
          .subtract(1, 'year')
          .format('YYYY-MM-DD'),
      // 结束时间
      edt: null || moment().format('YYYY-MM-DD')
    }
  },
  methods: {
    async echarts() {
      let res = await bigfloaterkb(
        this.equipid,
        this.number,
        this.bdt,
        this.edt
      )
      let data3 = res.data.AppendData.eqparam
      let titlelist1 = data3
      this.titlelist = titlelist1

      // const echarts = require('echarts')
      myChart = echarts.init(document.getElementById('main'))

      let data4 = res.data.AppendData.eqhistory
      let biaogelist = JSON.parse(data4)

      var m = {}
      data3.map(item => {
        biaogelist.map(data3 => {
          if (!(m[item.paramnm] instanceof Array)) {
            m[item.paramnm] = []
          }
          m[item.paramnm].push([data3['时间'], data3[item.paramnm]])
        })
      })
      let data3array = Object.values(m)
      myChart.setOption({
        legend: {
          borderWidth: 0,
          top: '10%',
          data: [
            {
              name: titlelist1[0].paramnm,
              icon: 'circle'
            },
            {
              name: titlelist1[1].paramnm,
              icon: 'circle'
            },
            {
              name: titlelist1[2].paramnm,
              icon: 'circle'
            },
            {
              name: titlelist1[3].paramnm,
              icon: 'circle'
            },
            {
              name: titlelist1[4].paramnm,
              icon: 'circle'
            },
            {
              name: titlelist1[5].paramnm,
              icon: 'circle'
            },
            {
              name: titlelist1[6].paramnm,
              icon: 'circle'
            },
            {
              name: titlelist1[7].paramnm,
              icon: 'circle'
            }
          ]
        },

        xAxis: {
          type: 'time',
          boundaryGap: false,
          splitNumber: 16
        },
        yAxis: {
          type: 'value',
          splitLine: {
            lineStyle: {
              type: 'dashed'
            }
          }
        },
        grid: { height: 160 },
        series: [
          {
            data: data3array[0],
            name: titlelist1[0].paramnm,
            showSymbol: false,
            hoverAnimation: false,
            type: 'line',
            smooth: true,
            seriesLayoutBy: 'row',
            symbol: 'none',
            areaStyle: {
              color: '#D4E8FF'
            },
            lineStyle: {
              shadowColor: '#5C97FD',
              shadowBlur: 10,
              color: '#5C97FD'
            },
            itemStyle: {
              color: '#5C97FD'
            }
          },
          {
            data: data3array[1],
            name: titlelist1[1].paramnm,
            type: 'line',
            smooth: true,
            seriesLayoutBy: 'row',
            symbol: 'none',
            areaStyle: {
              color: '#D4E8FF'
            },
            lineStyle: {
              shadowColor: '#36CFC9',
              shadowBlur: 10,
              color: '#36CFC9'
            },
            itemStyle: {
              color: '#36CFC9'
            }
          },
          {
            name: titlelist1[2].paramnm,
            data: data3array[2],
            type: 'line',
            smooth: true,
            seriesLayoutBy: 'row',
            symbol: 'none',
            areaStyle: {
              color: '#D4E8FF'
            },
            lineStyle: {
              shadowColor: '#A26DEB',
              shadowBlur: 10,
              color: '#A26DEB'
            },
            itemStyle: {
              color: '#A26DEB'
            }
          },
          {
            name: titlelist1[3].paramnm,
            data: data3array[3],
            type: 'line',
            smooth: true,
            seriesLayoutBy: 'row',
            symbol: 'none',
            areaStyle: {
              color: '#D4E8FF'
            },
            lineStyle: {
              shadowColor: '#F759AB',
              shadowBlur: 10,
              color: '#F759AB'
            },
            itemStyle: {
              color: '#F759AB'
            }
          },
          {
            name: titlelist1[4].paramnm,
            data: data3array[4],
            type: 'line',
            smooth: true,
            seriesLayoutBy: 'row',
            symbol: 'none',
            areaStyle: {
              color: '#D4E8FF'
            },
            lineStyle: {
              shadowColor: '#FFF566',
              shadowBlur: 10,
              color: '#FFF566'
            },
            itemStyle: {
              color: '#FFF566'
            }
          },
          {
            name: titlelist1[5].paramnm,
            data: data3array[5],
            type: 'line',
            smooth: true,
            seriesLayoutBy: 'row',
            symbol: 'none',
            areaStyle: {
              color: '#D4E8FF'
            },
            lineStyle: {
              shadowColor: '#FFC53D',
              shadowBlur: 10,
              color: '#FFC53D'
            },
            itemStyle: {
              color: '#FFC53D'
            }
          },
          {
            name: titlelist1[6].paramnm,
            data: data3array[6],
            type: 'line',
            smooth: true,
            seriesLayoutBy: 'row',
            symbol: 'none',
            areaStyle: {
              color: '#D4E8FF'
            },
            lineStyle: {
              shadowColor: '#FF7A45',
              shadowBlur: 10,
              color: '#FF7A45'
            },
            itemStyle: {
              color: '#FF7A45'
            }
          },
          {
            name: titlelist1[7].paramnm,
            data: data3array[7],
            type: 'line',
            smooth: true,
            seriesLayoutBy: 'row',
            symbol: 'none',
            areaStyle: {
              color: '#D4E8FF'
            },
            lineStyle: {
              shadowColor: '#FF4D4F',
              shadowBlur: 10,
              color: '#FF4D4F'
            },
            itemStyle: {
              color: '#FF4D4F'
            }
          }
        ]
      })
    },
    async shuju() {
      let res = await bigfloaterkb(
        this.equipid,
        this.number,
        this.bdt,
        this.edt
      )
      let data = res.data.AppendData.eqdata
      let leftlist = JSON.parse(data)

      let leftlistcopy = leftlist[0]
      let leftsj = Object.values(leftlistcopy)

      this.jd = leftsj[2]
      this.wd = leftsj[4]
      this.lg = leftsj[8]
      this.bzq = leftsj[10]
      this.bx = leftsj[11]
      this.wend = leftsj[9]
      this.qy = leftsj[7]
      this.dy = leftsj[12]
      this.fx = leftsj[13]
      this.fs = leftsj[6]
      let num = parseFloat(this.fx)
      this.fx1 = num.toFixed(0)

      this.bx2 = this.zdbx - 140
      let data2 = res.data.AppendData.eqmax
      let maxlist = JSON.parse(data2)
      let maxlistcopy = maxlist[0]
      let maxsj = Object.values(maxlistcopy)
      this.sj = leftsj[1]
      this.zdfs = maxsj[0]
      this.zdfx = maxsj[7]
      this.zdbg = maxsj[3]
      this.zbzq = maxsj[2]
      this.zdbx = maxsj[5]
      let num1 = parseFloat(this.zdbx)
      this.bx1 = num1.toFixed(0)
      let data4 = res.data.AppendData.eqhistory
      let biaogelist = JSON.parse(data4)

      let data3 = res.data.AppendData.eqparam
      var m = {}
      data3.map(item => {
        biaogelist.map(data3 => {
          if (!(m[item.paramnm] instanceof Array)) {
            m[item.paramnm] = []
          }
          m[item.paramnm].push([data3['时间'], data3[item.paramnm]])
        })
      })

      let data3array = Object.values(m)
      this.newfsdata.push(data3array[0])
      let newfsdata1 = []
      for (let i in this.newfsdata[0]) {
        newfsdata1.push(this.newfsdata[0][i])
      }
      this.newfsdata = newfsdata1.reverse()

      this.newfxdata.push(data3array[7])
      let newfxdata1 = []
      for (let i in this.newfxdata[0]) {
        newfxdata1.push(this.newfxdata[0][i])
      }
      this.newfxdata = newfxdata1.reverse()

      this.newbgdata.push(data3array[2])
      let newbgdata1 = []
      for (let i in this.newbgdata[0]) {
        newbgdata1.push(this.newbgdata[0][i])
      }
      this.newbgdata = newbgdata1.reverse()

      this.newbxdata.push(data3array[5])
      let newbxdata1 = []
      for (let i in this.newbxdata[0]) {
        newbxdata1.push(this.newbxdata[0][i])
      }
      this.newbxdata = newbxdata1.reverse()
    }
  },
  async mounted() {
    this.echarts()
    this.shuju()
  }
}
</script>
<style lang="scss" scoped>
.grid-content,
.bg-purple {
  width: 380px;
  margin-left: 20px;
  .title {
    width: 300px;
    height: 60px;
    background: rgba(92, 151, 253, 1);
    border-radius: 30px 0px 30px 0px;
  }
  .title-text {
    text-align: center;
    padding-top: 18px;
    font-size: 16px;
    color: aliceblue;
  }
  .second {
    height: 150px;
    //background-color: aqua;
    margin-top: 30px;
  }
  .second-two {
    margin-top: 10px;
  }
  .kuang1 {
    width: 90px;
    height: 55px;
    margin-left: 20px;
    line-height: 27px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 10px 0px rgba(203, 223, 254, 1);
    border-radius: 15px;
    border: 1.5px solid #cbdffe;
  }
  .kuang1-text1 {
    height: 10px;

    font-size: 3px;
    color: rgba(92, 92, 92, 1);
    text-align: center;
  }
  .kuang1-text {
    height: 30px;
    font-size: 14px;
    margin-top: 10px;
    text-align: center;
  }
  .kuang2 {
    width: 90px;
    height: 55px;
    margin-left: 55px;
    line-height: 27px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 10px 0px rgba(203, 223, 254, 1);
    border-radius: 15px;

    border: 1.5px solid #cbdffe;
  }
  .third {
    height: 120px;
    margin-top: 25px;
    margin-right: 80px;
    //background-color: aqua;
  }
  .left-third {
    margin-left: 10px;
  }
  .third-one {
    height: 90px;
    //background-color: chartreuse;
  }
  .svg1 {
    width: 100px;
    height: 100px;
  }
  .third-two {
    height: 90px;
    margin-left: 30px;
  }
  .third-three {
    height: 90px;
    margin-left: 30px;
  }
  .inner-text {
    text-align: center;
    font-size: 12px;
  }
  .inner-text1 {
    text-align: center;
    margin-top: 60px;
    font-size: 40px;
    color: rgba(0, 0, 0, 0.85);
  }
  .inner-text10 {
    font-size: 30px;
    color: darkgray;
    text-align: center;
  }
  .forth {
    margin-top: 150px;
    margin-left: 0px;
  }

  .for-one {
    width: 170px;
    height: 170px;
    border-radius: 50%;
    box-shadow: 0px 0px 10px 0px rgba(203, 223, 254, 1);
    border: 1.5px solid rgba(92, 151, 253, 1);
  }

  .flexbox {
    display: flex;
  }
  .for-two1 {
    margin-left: 10px;
    margin-top: 15px;
    width: 80px;
    height: 45px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 10px 0px rgba(203, 223, 254, 1);
    border-radius: 15px;
    border: 1.5px solid #cbdffe;
  }
  .kedu {
    margin-top: 17px;
    margin-left: 17px;
  }
  .kedu1 {
    border-radius: 30%;
  }
  .for-one1 {
    position: relative;
    margin-top: -118px;
    top: 0px;
    margin-left: 37px;
    width: 100px;
    height: 100px;
    background-image: linear-gradient(to right, #467fff, #64ffe4);
    border-radius: 50%;
  }
  .for-one2 {
    position: relative;
    margin-top: -100px;
    top: 12px;
    margin-left: 48px;
    width: 78px;
    height: 78px;
    background-color: white;
    // transform: rotate(90deg);
    border-radius: 50%;
  }
  .for-one2 img {
    width: 78px;
    height: 78px;
    border-radius: 50%;
  }
  .for-one4 {
    position: relative;
    background-color: white;
    height: 30px;
    width: 30px;
    margin-top: -42px;
    margin-left: 72px;
    text-align: center;
    font-size: 20px;
    line-height: 30px;
  }
  .for-two2 {
    margin-top: 15px;
    margin-left: 10px;
    width: 80px;
    height: 45px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 10px 0px rgba(203, 223, 254, 1);
    border-radius: 15px;
    border: 2px solid #cbdffe;
  }
  .for-two1text {
    margin-top: 5px;
    text-align: center;
    font-size: 6px;
    font-family: NotoSansHans-Regular;
    font-weight: 400;
    color: rgba(92, 92, 92, 1);
  }
  .for-two1text1 {
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    color: rgba(38, 38, 38, 1);
  }
}

.grid-content1,
.bg-purple1 {
  .right-frist {
    height: 350px;
    //background-color: cadetblue;
  }
  .right-title {
    margin-left: -100px;
    margin-top: 15px;
    height: 60px;
    background: rgba(255, 255, 255, 1);
  }
  .photo {
    width: 60px;
    height: 60px;
  }
  .flexbox {
    display: flex;
  }
  .time-text {
    font-size: 16px;
    margin-left: 10px;
    margin-top: 13px;
    color: rgba(41, 41, 41, 1);
  }
  .time-data {
    font-size: 20px;
    margin-left: 18px;
    margin-top: 11px;
    color: rgba(41, 41, 41, 1);
  }
  .time-data1 {
    font-size: 20px;
    margin-left: 18px;
    margin-top: 11px;
    color: rgba(41, 41, 41, 1);
  }
  .shuju {
    height: 25px;
    // background-color: aqua;
  }
  .quan-text {
    margin-left: 4px;
    font-size: 3px;
    color: rgba(169, 169, 169, 1);
  }
  .quxiantu {
    height: 220px;
  }
  .button {
    width: 100px;
    height: 30px;
    background-color: rgba(92, 151, 253, 1);
    border: 4px solid rgba(92, 151, 253, 1);
    border-radius: 4px;
    color: rgba(92, 92, 92, 1);
    margin-left: 30px;
  }
  .biaoge {
    margin-top: 60px;
    margin-left: 20px;
  }
  .biaoge-one {
    margin-left: -120px;
  }
  .biaoge-one1 {
    height: 51px;
    background-color: #cccccc;
    border: 0.5px solid #cccccc;
  }
  .biaoge-one11 {
    width: 50px;
    background-color: #d4e8ff;
    margin: 0.5px 0.5px 0.5px 0.5px;
    font-size: 10px;
    padding-top: 15px;
    text-align: center;
  }
  .biaoge-one12 {
    width: 95px;
    background-color: white;
    margin: 0.5px 0.5px 0.5px 1px;
  }
  .biaoge-one121 {
    width: 90px;
    background-color: white;
    margin: 0.5px 0.5px 0.5px 1px;
  }
  .biaoge-one131 {
    width: 90px;
    background-color: white;
    margin: 0.5px 0.5px 0.5px 1px;
  }
  .biaoge-one141 {
    width: 90px;
    background-color: white;
    margin: 0.5px 0.5px 0.5px 0.5px;
  }
  .one12-text1 {
    height: 25.5px;
    text-align: center;
    line-height: 25.5px;
    font-size: 12px;
    color: #5c5c5c;
  }
  .one12-text20 {
    height: 25px;
    text-align: center;
    font-size: 8px;
  }
  .one12-text2 {
    height: 25px;
    text-align: center;
    margin-top: -5px;
    font-size: 8px;
  }

  .biaoge-one2 {
    margin-top: 10px;
  }
  .biaoge-one21 {
    height: 40px;
    background-color: #d4e8ff;
    border: 0.5px solid #cccccc;
  }
  .biaoge-one211 {
    width: 50px;
    line-height: 40px;
    text-align: center;
  }
  .biaoge-one212 {
    width: 90px;
    line-height: 40px;
    text-align: center;
  }
  .biaoge-one213 {
    width: 90px;
    line-height: 40px;
    text-align: center;
  }
  .biaoge-one214 {
    width: 90px;
    line-height: 40px;
    text-align: center;
  }
  .biaoge-one22 {
    height: 45px;
    background-color: #cccccc;
    border-bottom: 0.5px solid #cccccc;
  }
  .biaoge-one221 {
    width: 50px;
    background-color: white;
    margin: 0.5px 0.5px 0.5px 1px;
    line-height: 45px;
    text-align: center;
  }
  .biaoge-one222 {
    width: 90px;
    background-color: white;
    margin: 0.5px 0.5px 0.5px 0.5px;
    text-align: center;
    font-size: 8px;
    padding-top: 10px;
  }
  .biaoge-one223 {
    width: 90px;
    background-color: white;
    margin: 0.5px 0.5px 0.5px 0.5px;
    line-height: 45px;
    text-align: center;
    font-size: 8px;
  }
  .biaoge-one224 {
    width: 90px;
    background-color: white;
    margin: 0.5px 1px 0.5px 0.5px;
    line-height: 45px;
    text-align: center;
    font-size: 8px;
  }
  .biaoge-one23 {
    height: 45px;
    background-color: #cccccc;
  }
  .biaoge-one24 {
    height: 45px;
    background-color: #cccccc;
  }
  .biaoge-one25 {
    height: 45px;
    background-color: #cccccc;
  }
  .biaoge-one26 {
    height: 45px;
    background-color: #cccccc;
  }
  .biaoge-two {
    margin-left: 20px;
  }
  .biaoge-two1 {
    height: 51px;
    background-color: #cccccc;
  }
  .biaoge-two11 {
    width: 50px;
    background-color: #d4e8ff;
    margin: 1px 0.5px 1px 1px;
    font-size: 10px;
    padding-top: 15px;
    text-align: center;
  }
  .biaoge-two12 {
    width: 90px;
    background-color: white;
    margin: 0.5px 0.5px 1px 0.5px;
  }
  .biaoge-two13 {
    width: 90px;
    background-color: white;
    margin: 0.5px 0.5px 1px 0.5px;
  }
  .biaoge-two14 {
    width: 90px;
    background-color: white;
    margin: 0.5px 1px 1px 0.5px;
  }
  .biaoge-two15 {
    width: 90px;
    background-color: white;
    margin: 0.5px 0.5px 1px 0.5px;
  }
  .biaoge-two2 {
    margin-top: 10px;
  }
  .biaoge-two21 {
    height: 40px;
    background-color: #d4e8ff;

    border: 0.5px solid #cccccc;
  }
  .biaoge-two211 {
    width: 45px;
    line-height: 45px;
    text-align: center;
  }
  .biaoge-two212 {
    width: 90px;
    line-height: 45px;
    text-align: center;
  }
  .biaoge-two213 {
    width: 90px;
    line-height: 45px;
    text-align: center;
  }
  .biaoge-two214 {
    width: 90px;
    line-height: 45px;
    text-align: center;
  }
  .biaoge-two215 {
    width: 90px;
    line-height: 45px;
    text-align: center;
  }
  .biaoge-two22 {
    height: 45px;
    background-color: #cccccc;
    border-bottom: 0.5px solid #cccccc;
  }
  .biaoge-two221 {
    width: 45px;
    background-color: white;
    margin: 0.5px 0.5px 0.5px 1px;
    line-height: 45px;
    text-align: center;
  }
  .biaoge-two222 {
    width: 90px;
    background-color: white;
    margin: 0.5px 0.5px 0.5px 0.5px;
    text-align: center;
    font-size: 8px;
    padding-top: 10px;
  }
  .biaoge-two223 {
    width: 90px;
    background-color: white;
    margin: 0.5px 0.5px 0.5px 0.5px;
    line-height: 45px;
    text-align: center;
    font-size: 8px;
  }
  .biaoge-two224 {
    width: 90px;
    background-color: white;
    margin: 0.5px 0.5px 0.5px 0.5px;
    line-height: 45px;
    text-align: center;
    font-size: 8px;
  }
  .biaoge-two225 {
    width: 95px;
    background-color: white;
    margin: 0.5px 1px 0.5px 0.5px;
    line-height: 45px;
    text-align: center;
    font-size: 8px;
  }
  .biaoge-two23 {
    height: 45px;
    background-color: #cccccc;
  }
  .biaoge-two24 {
    height: 45px;
    background-color: #cccccc;
  }
  .biaoge-two25 {
    height: 45px;
    background-color: #cccccc;
  }
  .biaoge-two26 {
    height: 45px;
    background-color: #cccccc;
  }
  .biaoge-four {
    margin-left: 20px;
  }
  .biaoge-four1 {
    width: 100px;
    margin-left: -20px;
    height: 30px;
    margin-top: 20px;
    line-height: 30px;
    padding-left: 58px;
  }
  .biaoge-four2 {
    width: 90px;
    height: 70px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 10px 0px rgba(203, 223, 254, 1);
    border-radius: 23px;
    border: 1.5px solid #cbdffe;
    margin-left: 10px;
  }
  .biaoge-four21 {
    margin-top: 15px;
    margin-left: 5px;
    opacity: 0.4996;
    font-size: 17px;
  }
  .biaoge-four22 {
    margin-top: 10px;
    margin-left: 25px;
    color: black;
  }
  .biaoge-four3 {
    width: 90px;
    height: 30px;
    margin-left: -20px;
    margin-top: 10px;
    line-height: 30px;
    padding-left: 58px;
  }
  .biaoge-four41 {
    width: 110px;
    height: 110px;
    margin-left: 5px;
    border-radius: 50%;
    border: 2px solid rgba(92, 151, 253, 1);
  }
  .biaoge-four411 {
    width: 85px;
    height: 85px;
    margin-left: 13px;
    margin-top: 14px;
    border-radius: 50%;
    background-image: linear-gradient(to right, #467fff, #64ffe4);
  }
  .biaoge-four412 {
    position: relative;
    width: 68px;
    height: 68px;
    margin-left: 22px;
    margin-top: -76px;
    border-radius: 50%;
    background-color: white;
  }
  .biaoge-four413 {
    position: relative;
    width: 15px;
    height: 20px;
    margin-left: 23px;
    margin-top: -45px;
    border-radius: 10px;
    // background-color: yellow;
    padding-left: 50px;
    padding-top: 3px;
  }
  .sanjiao {
    margin-top: 80px;
    margin-left: 130px;
  }
  .boxiang {
    position: relative;
    margin-left: 18px;
    padding-top: 25px;
  }
}
#main {
  height: 250px;
  margin-top: -45px;
  margin-left: -170px;
}
</style>
